// Loader.js
import React from "react";
import { CircularProgress, Box } from "@mui/material";

const Loader = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        bgcolor: "rgba(0, 0, 0, 0.5)", // Dimmed background
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999, // Ensure it is on top of other content
        pointerEvents: "all", // Allows clicks to pass through
      }}
      className=""
    >
      <CircularProgress className="loader-spinner" />
    </Box>
  );
};

export default Loader;
